/**
 * Organization API
 *
 * Wraps around the Organization API endpoint. For fetching data related to any tables we use
 */
import API from 'API';
import mockData from './mockData';

const api = new API();
const service = 'organization';
const path = '/organization';

const organization = {
  mock: () => api.setMock(mockData),
  live: () => api.setMock(null),
  list: payload => api.exec({
    action: 'get',
    service,
    path,
    payload: {
      active: payload.active,
      organizationId: payload.organizationId,
    },
  }),
  create: init => api.exec({
    action: 'post',
    service,
    path,
    init: {
      headers: init.headers,
      body: init.body,
    },
  }),
  update: mixedData => api.exec({
    action: 'put',
    service,
    path,
    payload: {
      active: mixedData.payload.active,
      organizationId: mixedData.payload.organizationId,
    },
    init: {
      headers: mixedData.headers,
      body: mixedData.body,
    },
  }),
  delete: payload => api.exec({
    action: 'del',
    service,
    path,
    payload: {
      active: payload.active,
      organizationId: payload.organizationId,
    },
  }),
};

export default organization;
